export const PREV_ARROW_TYPE = 'prev';

export const NEXT_ARROW_TYPE = 'next';
